<template>
  <div class="zhuaqiu-join-page">
    <img class="top-bg" src="/static/images/zq/bg2.png" />
    <div class="content-container">
      <img class="logo" src="/static/images/zq/logo.png" />
      <img class="system" src="/static/images/zq/system.png" />
      <img class="pitou2" src="/static/images/zq/pitou2.png" />
      <div class="result-content">
        <div class="result-message">查询产品为正品，请放心使用！</div>
        <div class="points-section">
          <img class="jf-img" src="/static/images/zq/jf.png" />
          <div class="points-text">{{ pointsClaimed ? '积分已被领取' : '恭喜获得' + points + '积分！' }}</div>
        </div>
        <div class="product-info">
          <div class="info-line">产品编码：{{ productId }}</div>
          <div class="info-line">商品名称：{{ productName }}</div>
        </div>
        <wx-open-launch-weapp
          class="shop-img"
          :appid="miniAppId"
          :username="miniAppOriginalId"
          :path="miniAppPage">
          <script type="text/wxtag-template">
            <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/shop-f430dfc159cf468fa11a3d875abc603c.png"
              style="width: 100%;height: auto;display: block;" />
          </script>
        </wx-open-launch-weapp>
      </div>
      <div class="bottom-bar"></div>
      <img class="bottom2" src="/static/images/zq/bottom2.png" />
    </div>
    <!-- Join页面内容 -->
  </div>
</template>

<style scoped>
.zhuaqiu-join-page {
  width: 100vw;
  min-height: 100vh;
  background-image: url('/static/images/zq/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
}

.top-bg {
  width: 100vw;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.content-container {
  position: relative;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

.logo {
  width: 16vw;
  height: auto;
  margin-top: 4vh;
}

.system {
  width: 85vw;
  height: auto;
  margin-top: 4vh;
}

.pitou2 {
  width: 45vw;
  height: auto;
  margin-top: 4vh;
}

.result-content {
  position: fixed;
  top: 45%;
  left: 50%;
  transform: translateX(-50%);
  width: 84vw;
  min-height: 40vh;
  background-color: white;
  border: 1px solid rgb(198, 0, 22);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding-left: 3vw;
}

.result-message {
  font-size: 3.3vw;
  color: rgb(198, 0, 22);
  text-align: center;
  margin-bottom: 4vh;
}

.points-section {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.jf-img {
  width: 10vw;
  height: auto;
  margin-right: 1vw;
}

.points-text {
  font-size: 4.6vw;
  color: rgb(198, 0, 22);
}

.product-info {
  width: 100%;
  padding-left: 12vw;
  margin-top: 3vh;
}

.info-line {
  font-size: 3.8vw;
  color:rgb(198, 0, 22);
  text-align: left;
  margin-bottom: 0.5vh;
}

.info-line:last-child {
  margin-bottom: 0;
}

.shop-img {
  width: 90%;
  height: auto;
  margin-top: 2vh;
}

.bottom-bar {
  width: 100vw;
  height: 5vh;
  background-color: rgb(198, 0, 22);
  position: fixed;
  bottom: 0;
  left: 0;
}

.bottom2 {
  width: 50vw;
  height: auto;
  position: fixed;
  bottom: 1vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

@media screen and (max-height: 600px) {
  .logo {
    width: 12vw;
  }

  .system {
    width: 75vw;
  }

  .pitou2 {
    width: 40vw;
  }

  .result-content {
    width: 74vw;
  }
}
</style>

<script>
import { getJSSDK, getScoreConfig, getTemplate, registerByOpenId, joinActivity, getTrace } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'ZhuaQiuJoin',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138495222640' : '138603493800',
      code: '',
      deptId: '',
      wyAuthCode: '',
      digit: '',
      appId: process.env.ENV_NUM === '1' ? 'wx22242a811779ec8c' : 'wxbc22565b3e7a59fd',
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      activityId: '',
      userToken: '',
      points: '',
      showPoints: false,
      pointsClaimed: false,
      productId: '',
      productName: ''
    }
  },
  methods: {
    async initPage() {
      await this.getScoreConfig();
      await this.getTemplate();
      await this.getProductInfo();
    },
    async getScoreConfig() {
      try {
        const res = await getScoreConfig(this.deptId);
        if (res.data.data != null) {
          this.shopUrl = res.data.data.shopUrl;
          const data = this.shopUrl.split('|');
          this.miniAppId = data[0];
          this.miniAppOriginalId = data[1];
          this.miniAppPage = data[2];
        }
      } catch (error) {
        console.error('获取积分配置失败:', error);
      }
    },
    async getTemplate() {
      try {
        const res = await getTemplate(this.deptId);
        if (res.data.data != null) {
          this.activityId = res.data.data.activityId;

          if (this.activityId) {
            await this.registerUser();
          }
        } else {
          alert("活动未开始或已下线，敬请留意最新活动信息");
        }
      } catch (error) {
        console.error('获取模板失败:', error);
        alert("活动未开始或已下线，敬请留意最新活动信息");
      }
    },
    async getProductInfo() {
      try {
        const res = await getTrace(this.digit, this.eno);
        if (res.data.code === 200 && res.data.data) {
          this.productId = res.data.data.productNo || '';
          this.productName = res.data.data.productName || '';
        }
      } catch (error) {
        console.error('获取产品信息失败:', error);
      }
    },
    async registerUser() {
      try {
        const res = await registerByOpenId(this.eno, this.wyAuthCode);
        if (res.data.code === "200") {
          console.log('用户注册成功:', res.data.data);
          this.userToken = res.data.data.token;
          await this.joinActivity();
        } else {
          alert("用户注册失败: " + (res.data.message || "未知错误"));
        }
      } catch (error) {
        console.error('注册用户失败:', error);
        alert("注册用户失败，请重试");
      }
    },
    async joinActivity() {
      try {
        const data = {
          code: this.code,
          activityId: this.activityId,
          authCode: this.wyAuthCode,
          userToken: this.userToken
        };

        const result = await joinActivity(data);
        if (result.data.code === "200") {
          console.log('参与活动成功:', result.data.data);
          this.points = result.data.data.giftValue || '';
          this.showPoints = true;
        } else if (result.data.code === "500001") {
          console.log('积分已领取');
          this.pointsClaimed = true;
          this.showPoints = true;
        } else {
          alert("参与活动失败，请联系客服处理");
        }
      } catch (error) {
        console.error('参与活动失败:', error);
        alert("参与活动失败，请联系客服处理");
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted() {
    const params = this.$route.query;
    const eno = params.eno;
    const code = params.c;
    const deptId = params.deptId;
    const wyAuthCode = params.wyAuthCode;
    const digit = params.digit;
    if (eno) {
      this.eno = eno;
    }
    if (code) {
      this.code = code ? code.substring(0, 16) : '';
    }
    if (deptId) {
      this.deptId = deptId;
    }
    if (wyAuthCode) {
      this.wyAuthCode = wyAuthCode;
    }
    if (digit) {
      this.digit = digit;
    }
    this.initPage();
    this.getWxJs();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ZhuaQiu/Join.vue